import {
  type GetLoyaltyEntitlementConsentEntitlementTypeEnum,
  LoyaltyEntitlementStatus,
} from '@packages/shared/src/hooks/useLoyaltyApi/useLoyaltyApi';
import type { ReactNode } from 'react';
import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from 'react-intl';
import { DeleteLoyaltyConnectionButton } from './DeleteLoyaltyConnectionButton.client';
import { UpdateLoyaltyEntitlementConsentButton } from './UpdateLoyaltyEntitlementConsentButton.client';

const messages = defineMessages({
  FurtherInformationDialogLink: {
    defaultMessage: 'Details/Widerruf',
    id: 'Payback.FurtherInformationDialog.Link',
  },
  AgreeNowDialogLink: {
    defaultMessage: 'Jetzt zustimmen',
    id: 'Payback.AgreeNowDialog.Link',
  },
});
type LoyaltyDialogConfig = {
  ctaNode: ReactNode;
  activateDialogText: MessageDescriptor;
};
// creates distinct mapped types for the different entitlement types + status
export const mappedEntitlementToStatus: Record<
  GetLoyaltyEntitlementConsentEntitlementTypeEnum,
  Record<LoyaltyEntitlementStatus, LoyaltyDialogConfig>
> = {
  marketing: {
    accepted: {
      activateDialogText: messages.FurtherInformationDialogLink,
      ctaNode: <UpdateLoyaltyEntitlementConsentButton status={LoyaltyEntitlementStatus.Rejected} />,
    },
    newVersion: {
      activateDialogText: messages.FurtherInformationDialogLink,
      ctaNode: <UpdateLoyaltyEntitlementConsentButton status={LoyaltyEntitlementStatus.Accepted} />,
    },
    rejected: {
      activateDialogText: messages.AgreeNowDialogLink,
      ctaNode: <UpdateLoyaltyEntitlementConsentButton status={LoyaltyEntitlementStatus.Accepted} />,
    },
  },
  service: {
    accepted: {
      activateDialogText: messages.FurtherInformationDialogLink,
      ctaNode: <DeleteLoyaltyConnectionButton />,
    },
    newVersion: {
      activateDialogText: messages.FurtherInformationDialogLink,
      ctaNode: <UpdateLoyaltyEntitlementConsentButton status={LoyaltyEntitlementStatus.Accepted} />,
    },
    rejected: {
      activateDialogText: messages.FurtherInformationDialogLink,
      ctaNode: <UpdateLoyaltyEntitlementConsentButton status={LoyaltyEntitlementStatus.Accepted} />,
    },
  },
};
